import React, { useEffect, useState } from "react";
import axios from "axios";
import * as API from "../Endpoints/Endpoints";
import { useNavigate } from 'react-router-dom';

const ChakraGameTable = () => {
    const [data, setData] = useState([]);
    const [view, setView] = useState("spoke"); // Default to Spoke data
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        fetchData(view);
    }, [view]);

    const fetchData = (type) => {
        const apiUrl = type === "spoke" ? API.GET_SPOKE_API : API.GET_BLADE_API;
        axios.get(apiUrl)
            .then(res => {
                console.log("Fetched Data:", res.data);  // Debugging
                setData(res.data);
            })
            .catch(err => {
                console.error("Error fetching data:", err);
                alert("Error fetching data: " + err);
            });
    };    

    const handleUpload = (e) => {
        const file = e.target.files[0];
        console.log(file); // Log the selected file
    
        if (file) {
            if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
                alert("Please upload an Excel file (xlsx or xls).");
                return;
            }
    
            const formData = new FormData();
            formData.append('file', file);
    
            // Upload the file with progress tracking
            axios.post(API.UPLOAD_CHAKRA_GAMES_API, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (progressEvent) => {
                    let percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    console.log(`Upload progress: ${percent}%`);
                    // You can also update a progress bar here with `percent`
                }
            }).then((res) => {
                alert("File uploaded and data added successfully");
                // getData(); // Refresh data after upload
            }).catch((err) => {
                console.error("Upload error:", err.response?.data || err.message);
                alert("Error uploading file: " + (err.response?.data?.message || err.message));
            });
        } else {
            alert("No file selected. Please choose a file to upload.");
        }
    };

     const DeleteSpoke = (spokeid) => {
            if (window.confirm("Are you sure you want to delete this spoke?")) {
                axios({
                    url: API.DELETE_SPOKE_API(spokeid),
                    method: 'DELETE',
                }).then((res) => {
                    alert("Deleted spoke successfully");
                    fetchData();
                }).catch((err) => {
                    alert("Error: " + err);
                });
            }
        };

        const DeleteBlade = (bladeid) => {
            if (window.confirm("Are you sure you want to delete this blade?")) {
                axios({
                    url: API.DELETE_BLADE_API(bladeid),
                    method: 'DELETE',
                }).then((res) => {
                    alert("Deleted blade successfully");
                    fetchData();
                }).catch((err) => {
                    alert("Error: " + err);
                });
            }
        };
    
    const ViewSpoke = (spokeid) => {
        navigate(`/viewspoke/${spokeid}`);
    };

    const UpdateSpoke = (spokeid) => {
        navigate(`/updatespoke/${spokeid}`);
    };

    const ViewBlade = (bladeid) => {
        navigate(`/viewblade/${bladeid}`);
    };

    const UpdateBlade = (bladeid) => {
        navigate(`/updateblade/${bladeid}`);
    };
      

    return (
        <div className="p-4">
            <div className="flex gap-4 mb-4">
                <button className={`p-2 border ${view === "spoke" ? "bg-[#e64a32] text-white" : "bg-gray-200"}`} 
                        onClick={() => setView("spoke")}>
                    Spoke Data
                </button>
                <button className={`p-2 border ${view === "blade" ? "bg-[#e64a32] text-white" : "bg-gray-200"}`} 
                        onClick={() => setView("blade")}>
                    Blade Data
                </button>
            </div>

           <div className="flex gap-4 mb-4"> <button className="bg-gray-200 text-black p-2 border " onClick={() => navigate("/addspoke")}>
                    Add Spoke
                </button>

                <button className="bg-gray-200 text-black p-2 border " onClick={() => navigate("/addblade")}>
                    Add Blade
                </button> </div>

           <div className="mt-2"> <input type="file" accept=".xlsx, .xls" onChange={handleUpload} className="mb-4" /> </div>

            <input 
                type="text" 
                placeholder="Search by theme, agent, spoke, or blade..."
                value={searchTerm} 
                onChange={(e) => setSearchTerm(e.target.value)} 
                className="p-2 border w-full mb-4"
            />

<table className="border-collapse w-full mt-4">
  <thead>
    <tr className="bg-[#e64a32] text-white">
      <th className="border p-2">Theme</th>
      <th className="border p-2">Agent Name</th>
      <th className="border p-2">Description</th>
      <th className="border p-2">{view === "spoke" ? "Spoke Number" : "Blade Number"}</th>
      <th className="border p-2">{view === "spoke" ? "Spoke" : "Blade"}</th>
      <th className="border p-2">Answer</th>
      <th className="border p-2">Action</th>
    </tr>
  </thead>
  <tbody>
    {view === "spoke" &&
      data
        .filter(row =>
          (row.theme || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
          (row.agentname || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
          (row.description || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
          (row.spoke || "").toLowerCase().includes(searchTerm.toLowerCase())
        )
        .map((row, index) => (
          <tr key={index} className="border">
            <td className="border p-2">{row.theme}</td>
            <td className="border p-2">{row.agentname}</td>
            <td className="border p-2">{row.description}</td>
            <td className="border p-2">{row.spokenumber}</td>
            <td className="border p-2">{row.spoke}</td>
            <td className="border p-2">{row.answer}</td>
            <td className="py-4 px-6 text-sm font-medium text-center text-gray-900 dark:text-white">
              <button onClick={() => ViewSpoke(row.spokeid)} className="bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1">View</button>
              <button onClick={() => UpdateSpoke(row.spokeid)} className="bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1 mt-2">Edit</button>
              <button onClick={() => DeleteSpoke(row.spokeid)} className="bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1 mt-2">Delete</button>
            </td>
          </tr>
        ))
    }

    {view === "blade" &&
      data
        .filter(row =>
          (row.theme || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
          (row.agentname || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
          (row.description || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
          (row.blade || "").toLowerCase().includes(searchTerm.toLowerCase())
        )
        .map((row, index) => (
          <tr key={index} className="border">
            <td className="border p-2">{row.theme}</td>
            <td className="border p-2">{row.agentname}</td>
            <td className="border p-2">{row.description}</td>
            <td className="border p-2">{row.bladenumber}</td>
            <td className="border p-2">{row.blade}</td>
            <td className="border p-2">{row.answer}</td>
            <td className="py-4 px-6 text-sm font-medium text-center text-gray-900 dark:text-white">
              <button onClick={() => ViewBlade(row.bladeid)} className="bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1">View</button>
              <button onClick={() => UpdateBlade(row.bladeid)} className="bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1 mt-2">Edit</button>
              <button onClick={() => DeleteBlade(row.bladeid)} className="bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1 mt-2">Delete</button>
            </td>
          </tr>
        ))
    }
  </tbody>
</table>
        </div>
    );
};

export default ChakraGameTable;
